// simple moving average

import { isNumber } from './common';
export default (function (data, size) {
  var length = data.length;
  if (!size) {
    return data.reduce(function (a, b) {
      return a + b;
    }) / length;
  }
  if (size <= 1) {
    return data.slice();
  }
  if (size > length) {
    return Array(length);
  }
  var prepare = size - 1;
  var ret = [];
  var sum = 0;
  var i = 0;
  var counter = 0;
  var datum;
  for (; i < length && counter < prepare; i++) {
    datum = data[i];
    if (isNumber(datum)) {
      sum += datum;
      counter++;
    }
  }
  for (; i < length; i++) {
    datum = data[i];
    if (isNumber(datum)) {
      sum += datum;
    }
    if (isNumber(data[i - size])) {
      sum -= data[i - size];
    }
    ret[i] = sum / size;
  }
  return ret;
});